<template>
  <div class="query-keys">
    <template v-if="data && data.length > 0">
      <p class="query-keys__text">抱歉，未找到相关内容，你是不是想找：</p>
      <div class="recommend-query">
        <div class="recommend-query__content">
          <router-link
            v-for="(item, index) in data"
            :key="index"
            class="recommend-query__link"
            :to="{ name: 'search', query: { keyword: item } }"
            @click.native="
              handlePushLog(
                'xeslog-noCourserecommendQuery-search',
                item,
                index,
                '1.4.28',
                $event
              )
            "
            >{{ item }}</router-link
          >
        </div>
      </div>
    </template>
    <template v-else>
      <p class="query-keys__text">抱歉，未找到相关课程</p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import xss from 'xss'
import { Base64 } from 'js-base64'
import Cookies from 'js-cookie'

export default {
  props: ['data'],
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userIsLogin: state => state.userIsLogin,
      dataExpTag: state => state.SearchPage.dataExpTag,
      userInfo: state => state.user && state.user.userInfo
    })
  },
  methods: {
    handlePushLog(key, item, index, clickid, event) {
      // console.log('=======handlePushLog======', item)
      this.pushHistory(item)
      // this.searchWord = item
      this.xesLog(
        'click',
        {
          key,
          clickid,
          clickurl: `${window.location.protocol}//online.xueersi.com/search?keyword=${item}`,
          recquery: item,
          orderid: index,
          setgradeid: this.$store.state.cookies.userGrade,
          curgradeid: this.$store.state.cookies.currentGrade,
          query: this.$route.query.keyword,
          exp_tag: this.dataExpTag
        },
        event.target
      )
    },
    pushHistory(keyword) {
      let value = xss(keyword).trim()
      if (!value) return
      if (value.length > 38) value = value.slice(0, 38)
      
      // 将搜索词追加到搜索历史
      this.addSearchHistory({keyWord: value})
    },
    xesLog(eventName, params, target) {
      const XESLog = new this.$XESLog({
        ...params
      })
      XESLog.push({ eventname: eventName, target }, this.$route)
    },
    // 往搜索历史添加词
    addSearchHistory({ keyWord }) {
      let history = []

      const words = Cookies.get('search_history')

      if(words) {
        history = history.concat(Base64.decode(words).split(','))
      }

      // 如果搜索历史已存在该字段，需要先删除
      if (history.indexOf(keyWord) !== -1) {
        history.splice(history.indexOf(keyWord), 1)
      }

      history.unshift(keyWord)

      history = history.slice(0, 10) // 只存10个搜索词

      Cookies.set('search_history', Base64.encode(history.join(',')), { expires: 7, domain: '.xueersi.com' });     
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(query-keys) {
  height: 80px;
  background-color: #ffffff;
  padding: 0 38px;
  @include e(text) {
    display: inline-block;
    line-height: 80px;
    font-size: 14px;
  }
}
@include b(recommend-query) {
  display: inline-block;
  line-height: 80px;
  position: relative;
  border-radius: 20px;
  transition: all 0.3s;
  color: #333333;
  vertical-align: middle;
  .recommend-query__content {
    a {
      display: inline-block;
      font-size: 12px;
      color: #999999;
      background: #f2f2f5;
      border-radius: 17px;
      padding: 0 20px;
      margin-right: 10px;
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/SearchPage/components/QueryKeys.vue